import { addDays, isSameDay, startOfDay } from 'date-fns';

export type DayPart = 'whole' | 'half';

export function calculateLeaveDays(params: {
  startDate: Date;
  endDate: Date;
  startPart?: DayPart;
  endPart?: DayPart;
  excludeSundays?: boolean;
}): number {
  const {
    startDate,
    endDate,
    startPart = 'whole',
    endPart = 'whole',
    excludeSundays = true,
  } = params;

  const start = startOfDay(startDate);
  const end = startOfDay(endDate);

  if (end < start) return 0;

  // Special case: same day selection
  if (isSameDay(start, end)) {
    if (excludeSundays && start.getDay() === 0) return 0;
    if (startPart === 'half' && endPart === 'half') return 0.5;
    return 1;
  }

  // Count working days inclusive
  let days = 0;
  for (let d = start; d <= end; d = addDays(d, 1)) {
    if (excludeSundays && d.getDay() === 0) continue;
    days += 1;
  }

  // Apply half-day adjustments at the ends (only if that end isn't a Sunday)
  const startIsSunday = start.getDay() === 0;
  const endIsSunday = end.getDay() === 0;

  if (!(excludeSundays && startIsSunday) && startPart === 'half') days -= 0.5;
  if (!(excludeSundays && endIsSunday) && endPart === 'half') days -= 0.5;

  return Math.max(0, Math.round(days * 2) / 2);
}

